<mat-card>
  <mat-card-header>
    <mat-card-title>{{nombre}}</mat-card-title>
    <mat-card-subtitle>{{fecha}}</mat-card-subtitle>
  </mat-card-header>
  <mat-card-content>
    <p>{{mensaje.mensajeContenido}}</p>
  </mat-card-content>
  <mat-card-actions>
  </mat-card-actions>
</mat-card>
